import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
export const fetchGames = createAsyncThunk(
  "games/fetchGames",
  async (date, { rejectWithValue }) => {
    try {
      let api_response_data = {};

      const start_date = new Date(Date.now() - 24 * 60 * 60 * 1000)
        .toISOString()
        .split("T")[0];
      const upcoming_response = await axios.get(
        `${process.env.REACT_APP_API_ENDPOINT_URL_BALLDONTLIE}/games`,
        {
          params: {
            "team_ids[]": 14,
            per_page: 3,
            start_date: start_date,
          },
          headers: {
            Authorization: process.env.REACT_APP_AUTHORIZATION_TOKEN,
          },
        }
      );

      const future_games = upcoming_response.data.data.filter(
        (game) => game.time != "Final" && new Date(game.status) > new Date()
      );
      const end_date = new Date(Date.now() - 86400000)
        .toISOString()
        .split("T")[0];
      const today = new Date();
      const oneMonthBack = new Date(today);
      oneMonthBack.setMonth(today.getMonth() - 3);
      const formattedOneMonthBack = oneMonthBack.toISOString().split("T")[0];

      const previous_response = await axios.get(
        `${process.env.REACT_APP_API_ENDPOINT_URL_BALLDONTLIE}/games`,
        {
          params: {
            "team_ids[]": 14,
            per_page: 45,
            start_date: formattedOneMonthBack,
            end_date: end_date,
          },
          headers: {
            Authorization: process.env.REACT_APP_AUTHORIZATION_TOKEN,
          },
        }
      );

      api_response_data.upcoming_response = future_games;
      api_response_data.previous_response = previous_response?.data?.data;
      return api_response_data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

const gamesSlice = createSlice({
  name: "games",
  initialState: {
    games: [],
    loading: false,
    status: "idle",
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchGames.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchGames.fulfilled, (state, action) => {
        state.loading = false;
        state.games = action.payload;
      })
      .addCase(fetchGames.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default gamesSlice.reducer;
